import { z } from 'zod'

/**
 * A reference to a Plate element (block) inside a host entity. Sibling
 * concept to `EntityRef`, but at the block level — `id` is the stable
 * Plate `block.id`, not an entity id.
 *
 * Lives in @tunasong/schemas (not plugin-lib) so server-runtime packages
 * (agent-tools, agent-runtime, ai-api Lambda) can read the schema without
 * pulling Plate/Slate/React. Used as the base shape for `AgentFocus` and
 * for affordance-discovery payloads.
 */
export const blockRefSchema = z.object({
  id: z.string().min(1).describe('Stable Plate element id within the host entity.'),
  type: z.string().min(1).describe("Plate element type, e.g., 'chord', 'line'."),
  entityId: z.string().min(1).describe('Host entity id.'),
  summary: z
    .string()
    .max(120)
    .describe('Short textual summary (≤120 chars). Builder picks; for chord: chord name; for line: line text.')
    .optional(),
})

export type BlockRef = z.infer<typeof blockRefSchema>
